import React, { useRef } from "react";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./components/HomePage";
import AdminPanel from "./components/AdminPanel";

function App() {
  const homePageRef = useRef(null);

  const scrollToSection = (section) => {
    if (homePageRef.current && homePageRef.current.scrollToSection) {
      homePageRef.current.scrollToSection(section);
    }
  };

  // ✅ Admin-Bereich über URL-Parameter zeigen
  const urlParams = new URLSearchParams(window.location.search);
  const isAdmin = urlParams.get('admin') === 'termine-verwaltung-2024-xyz';

  return (
    <div className="App">
      {isAdmin ? (
        <AdminPanel />
      ) : (
        <>
          <Header scrollToSection={scrollToSection} />
          <HomePage ref={homePageRef} />
          <Footer scrollToSection={scrollToSection} />
        </>
      )}
    </div>
  );
}

export default App;